import { KYMW1308Model } from '../kymw1308.model';
import { KYMW1308GetPromotionNoModel } from '../vo/kymw1308-get-promotion-no.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ画面　プロモーションNoを取得するサービス
 *
 * @export GetPromotionNoService
 * @class GetPromotionNoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPromotionNoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1308Model}
   * @memberof GetPromotionNoService
   */
  private model: KYMW1308Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1308GetPromotionNoModel}
   * @memberof GetPromotionNoService
   */
  private vo: KYMW1308GetPromotionNoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {string} リクエストJSON
   * @memberof GetPromotionNoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPromotionNoService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1308Model>model;
    this.vo = vo;
    this.send('getPromotionNo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPromotionNoService
   */
  success(data: any): void {
    this.model.updatePromotionNo(data);
    // 画面項目初期化
    this.model.KYMW1308Component.initDisplay();
    // ボタン活性制御
    this.model.KYMW1308Component.setEnabledBtn();
  }

}
